import { Accommodation } from 'models';

export class Trip {
    tripId: number;
    checkIn: Date;
    checkOut: Date;
    hostFirstName: string;
    hostLastName: string;
    hostFullName: string;
    hostEmail: string;
    hostTelephone: string;

    hostPostcode: string;
    hostAddressLine1: string;
    hostAddressLine2: string;
    hostTown: string;
    hostCountryId: number;

    shortSummary: string;

    superhogStagingGuestTripId: number;

    accommodation: Accommodation;

    constructor(props?: { [key in keyof Trip]?: Trip[key] }) {
        Object.assign(this, props);
    }
}


export class TripValidation {
    message: string;
    cost: number;
    isValid: boolean;
    verificationNeeded: boolean;
}
